import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const deliverables = ['Manual completo de 20 páginas', 'Plantillas de mensajes listas para usar'];
export function OfferSection() {
  return <section id="offer" className="py-24 px-4 bg-[#0A0A0A] relative overflow-hidden" data-id="element-40">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[600px] bg-[#1A7A4A]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-41" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#0f0f0f] border-2 border-[#C9A84C]/30 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(201,168,76,0.1)] text-center" data-id="element-43">
          <h2 id="payment" className="text-3xl md:text-4xl font-extrabold italic text-white mb-8" data-id="element-44">
            Tu Inversión Hoy
          </h2>

          <div className="mb-8 flex flex-col items-center justify-center" data-id="element-45">
            <span className="text-2xl text-neutral-500 line-through decoration-neutral-600 decoration-2 mb-2" data-id="element-46">
              $19 USD
            </span>
            <div className="flex items-baseline justify-center text-[#C9A84C] drop-shadow-[0_0_15px_rgba(201,168,76,0.5)]" data-id="element-47">
              <span className="text-4xl font-bold" data-id="element-48">$</span>
              <span className="text-8xl font-black tracking-tighter" data-id="element-49">6</span>
              <span className="text-5xl font-black tracking-tighter" data-id="element-50">.99</span>
              <span className="text-2xl font-bold ml-2" data-id="element-51">USD</span>
            </div>
          </div>

          <div className="flex flex-col items-center mb-10" data-id="element-52">
            <CTAButton text="QUIERO MI PRIMER SUELDO EN DÓLARES" href="https://pay.hotmart.com/M104839164S" className="w-full md:w-auto text-lg md:text-2xl py-5 px-10" data-id="element-53" />
            <p className="mt-4 text-neutral-500 text-sm" data-id="element-54">
              Descarga inmediata. Acceso de por vida.
            </p>
            <p className="mt-2 text-[#C9A84C] text-sm font-bold animate-pulse" data-id="element-55">
              Este precio solo está disponible hoy.
            </p>
          </div>

          <p className="text-xl text-[#D1D5DB] font-medium mb-10 max-w-lg mx-auto" data-id="element-56">
            Menos que una cena.{' '}
            <span className="text-[#1A7A4A] font-bold" data-id="element-57">
              Más que un sueldo mínimo completo transformado.
            </span>
          </p>

          <div className="bg-[#0A0A0A] rounded-2xl p-6 mb-10 text-left max-w-md mx-auto border border-neutral-800" data-id="element-58">
            <h3 className="text-white font-bold mb-4 text-center" data-id="element-59">
              Lo que te llevas ahora mismo:
            </h3>
            <ul className="space-y-3" data-id="element-60">
              {deliverables.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-61">
                  <CheckIcon className="w-5 h-5 text-[#1A7A4A] flex-shrink-0 mt-0.5" data-id="element-62" />
                  <span className="text-[#D1D5DB]" data-id="element-63">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="mb-10 flex items-center justify-center gap-3 text-[#D1D5DB]/70 bg-[#0A0A0A]/50 py-3 px-6 rounded-full border border-neutral-800 w-fit mx-auto" data-id="element-64">
            <LockIcon className="w-5 h-5 text-[#C9A84C]" data-id="element-65" />
            <span className="text-sm md:text-base" data-id="element-66">
              <strong className="text-white" data-id="element-67">Garantía de satisfacción:</strong>{' '}
              Si no te funciona, te devolvemos tu dinero.
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}